import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import SuccessModal from "../../SuccessModal";
import {
  createWarehouse,
  getBrandWarehouseById,
  putWarehouse,
} from "../../../services/warehouse/Warehouse";
import {
  addBrandOffer,
  getBrandSingleOffer,
  getOfferCategory,
  getOfferType,
  updateBrandOffer,
} from "../../../services/OfferManagements/OfferManagementConfig";
import { getBrandAppService } from "../../../services/BrandAppServices";
import { getBrandPriceCode } from "../../../services/StorePriceCode/getPriceCode";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import AdminMenu from "../../AdminMenu";

const OffersManagementCreate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = location.state || {}; // Fallback to prevent undefined errors
  const [visible, setVisible] = useState(false);

  const { userProfileRole, brandProfileData } = getUserData();
  const userRole = userProfileRole;
  let brandId = brandProfileData.id;
  let enabledGarmentProcessStageBrand =
    brandProfileData.enabledGarmentProcessStage;
  const [isUpdating, setIsUpdating] = useState(id);
  const [singleOfferData, setSingleOfferData] = useState({});
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");
  const [showValidToDatePicker, setShowValidToDatePicker] = useState(false);
  const [showValidFromDatePicker, setShowValidFromDatePicker] = useState(false);
  const [servicesModalVisible, setServicesModalVisible] = useState(false);
  const [appServiceList, setAppServiceList] = useState([]);
  const [priceListData, setPriceListData] = useState([]);

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedGarment, setSelectedGarment] = useState("");
  const [offerTypeData, setOfferTypeData] = useState([]);
  const [offerCategory, setOfferCategory] = useState([]);
  const [validityFromDateCheck, setValidityFromDateCheck] = useState(false);
  const [isSubmitButtonPressed, setIsSubmitButtonPressed] = useState(false);

  const fetchSingleOfferData = (id) => {
    getBrandSingleOffer(brandId, id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setSingleOfferData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    if (isUpdating !== null) {
      fetchSingleOfferData(isUpdating);
    }
  }, [isUpdating]);

  const fetchOffersData = () => {
    getBrandAppService(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setAppServiceList(res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getBrandPriceCode(brandId)
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          setPriceListData(res.prices);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getOfferCategory()
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          const newRes = res.map((item) => ({
            name: item.name,
            value: item.id,
          }));
          setOfferCategory(newRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getOfferType()
      .then((response) => {
        if (!response.data.error) {
          const res = response.data;
          const newRes = res.map((item) => ({
            name: item.name,
            value: item.id,
          }));
          setOfferTypeData(newRes);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  useEffect(() => {
    fetchOffersData();
  }, []);

  let initialDate = new Date();
  const minimumDate = new Date();
  //  minimumDate.setMonth(minimumDate.getMonth() + 3); // Add 3 months to current date

  const maximumDate = new Date();
  maximumDate.setMonth(maximumDate.getMonth() + 3);

  const maximumValidDate = maximumDate;

  const [input, setInput] = useState({
    offerName: "",
    offerCategory: "",
    offerType: "",
    offerValue: "",
    validTo: new Date(initialDate),
    validFrom: new Date(initialDate),
    status: "ACTIVE",
  });

  useEffect(() => {
    if (singleOfferData) {
      setInput((prevState) => ({
        ...prevState,
        offerName: singleOfferData?.brandOfferDTO?.name || "",
        offerCategory: singleOfferData?.brandOfferDTO?.offerCategory.id || "",
        offerType: singleOfferData?.brandOfferDTO?.offerType.id || "",
        offerValue: singleOfferData?.brandOfferDTO?.value?.toString() || "",
        validTo: singleOfferData?.brandOfferDTO?.validTo
          ? new Date(singleOfferData.brandOfferDTO?.validTo)
          : new Date(initialDate),
        validFrom: singleOfferData?.brandOfferDTO?.validFrom
          ? new Date(singleOfferData.brandOfferDTO?.validFrom)
          : new Date(initialDate),
        status: singleOfferData?.brandOfferDTO?.status || "ACTIVE",
      }));
      setSelectedServices(singleOfferData?.itemList || []);
      setSelectedGarment(singleOfferData?.brandOfferDTO?.priceId || "");
    }
  }, [singleOfferData]);

  const [offerNameError, setOfferNameError] = useState("");
  const [offerCategoryError, setOfferCategoryError] = useState("");
  const [offerTypeError, setOfferTypeError] = useState("");
  const [validToError, setValidToError] = useState("");
  const [validFromError, setValidFromError] = useState("");
  const [statusError, setStatusError] = useState("");
  const [serviceError, setServiceError] = useState("");
  const [garmentError, setGarmentError] = useState("");
  const [offerValueError, setOfferValueError] = useState("");

  const handleStatusChange = (selectedItem) => {
    // setStatusValue(selectedItem.value);
    setInput({
      ...input,
      status: selectedItem.value,
    });
  };

  const StatusList = [
    {
      name: "ACTIVE",
      value: "ACTIVE",
    },
    {
      name: "INACTIVE",
      value: "INACTIVE",
    },
  ];

  const [selectAll, setSelectAll] = useState(false); // State for "All"

  const handleServicesToggle = (service) => {
    let updatedServices;

    if (service === "All") {
      // If "All" is checked, select or deselect all services
      if (!selectAll) {
        updatedServices = appServiceList.map((item) => item.appService.id);
      } else {
        updatedServices = [];
      }
      setSelectAll(!selectAll);
    } else {
      // For individual services
      updatedServices = [...selectedServices];

      if (updatedServices.includes(service)) {
        updatedServices.splice(updatedServices.indexOf(service), 1);
      } else {
        updatedServices.push(service);
      }

      // If all services are selected individually, check "Select All"
      if (updatedServices.length === appServiceList.length) {
        setSelectAll(true);
      } else {
        setSelectAll(false);
      }
    }

    setSelectedServices(updatedServices);
    setServiceError("");
  };

  const handleGarmentsToggle = (garment) => {
    // const updatedGarment = [garment];
    setSelectedGarment(garment);
    setGarmentError("");
  };

  const handleOfferTypeChange = (selectedItem) => {
    setInput({
      ...input,
      offerType: selectedItem,
    });
    setOfferTypeError("");
  };

  const handleOfferCategoryChange = (selectedItem) => {
    setInput({
      ...input,
      offerCategory: selectedItem,
    });
    if (selectedItem === 2) {
      setSelectedServices([]);
      setSelectAll(false);
      setServiceError("");
    } else if (selectedItem === 1) {
      setSelectedGarment("");
      setGarmentError("");
    }
    setOfferCategoryError("");
  };

  const handleValidFromDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      // Prevent selection of previous dates
      // setErrorMessage('');
      if (selectedDate <= maximumValidDate) {
        if (selectedDate < input.validTo) {
          const utcDate = new Date(
            Date.UTC(
              selectedDate.getFullYear(),
              selectedDate.getMonth(),
              selectedDate.getDate()
            )
          );
          setInput({
            ...input,
            validFrom: utcDate,
          });
          setValidFromError(""); // Clear any previous errors
        } else {
          const utcDate = new Date();
          setInput({
            ...input,
            validFrom: utcDate,
          });
          setValidFromError(
            "Valid From Date can not be greater than Valid To Date"
          );
        }
      }
    }
    setShowValidFromDatePicker(false);
  };

  const handleValidToDateChange = (selectedDate) => {
    if (selectedDate !== undefined) {
      // Prevent selection of previous dates
      if (selectedDate >= input.validFrom) {
        const utcDate = new Date(
          Date.UTC(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate()
          )
        );
        setInput({
          ...input,
          validTo: utcDate,
        });
        setValidToError(""); // Clear any previous errors
        setValidFromError("");
      } else {
        setValidToError("Valid To Date can not be less than Valid From Date");
      }
    }
    setShowValidToDatePicker(false);
  };

  const toggleValidToDatePicker = () => {
    setShowValidToDatePicker(!showValidToDatePicker);
  };
  const toggleValidFromDatePicker = () => {
    setShowValidFromDatePicker(!showValidFromDatePicker);
  };

  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };

  const handleSubmit = () => {
    // Reset all previous errors
    setOfferNameError("");
    setOfferCategoryError("");
    setOfferTypeError("");
    setValidToError("");
    setValidFromError("");
    setStatusError("");
    setOfferValueError("");

    let isValid = true;
    if (!input.offerName) {
      setOfferNameError("Offer Name is Required");
      isValid = false;
    }
    if (!input.offerCategory) {
      setOfferCategoryError("Offer Category is Required");
      isValid = false;
    }
    if (!input.offerType) {
      setOfferTypeError("Offer Type is Required");
      isValid = false;
    }

    if (!input.offerValue) {
      setOfferValueError("Value can not be Empty");
      isValid = false;
    }
    if (!input.validFrom) {
      setValidToError("Valid From date is Required");
      isValid = false;
    }
    if (!input.validTo) {
      setValidFromError("Valid To Date is Required");
      isValid = false;
    }
    if (!input.status) {
      setStatusError("Status is Required");
      isValid = false;
    }
    if (input.offerCategory === 1 && selectedServices.length <= 0) {
      setServiceError("Please Select Services is Required");
      isValid = false;
    }
    if (input.offerCategory === 2 && selectedGarment === "") {
      setGarmentError("Please Select Tariff is Required");
      isValid = false;
    }
    // addBrandOffer;
    if (isValid) {
      if (!isSubmitButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsSubmitButtonPressed(true);

        if (!isUpdating) {
          // Logic for creating a new pickup request
          const data = {
            brandOfferDTO: {
              brandId: brandId,
              priceId: selectedGarment ? selectedGarment : null, // null for service
              name: input.offerName,
              value: input.offerValue,
              offerCategory: {
                id: input.offerCategory,
              },
              offerType: {
                id: input.offerType,
              },
              validFrom: input.validFrom.toISOString(),
              validTo: input.validTo.toISOString(),
              status: input.status,
            },
            itemList: selectedServices.length > 0 ? selectedServices : [],
          };
          // Call the service function for creating pickup request

          addBrandOffer(brandId, data)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  // Reset state variables
                  if (Res.status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(Res.message);
                    setTimeout(() => {
                      navigate("/OffersManagement");
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(Res.message);
                  }

                  setInput({
                    offerName: "",
                    offerValue: "",
                    offerCategory: "",
                    offerType: "",
                    validTo: new Date(initialDate),
                    validFrom: new Date(initialDate),
                    status: "",
                  });
                  setSelectedServices([]);
                  setSelectedGarment([]);

                  setOfferNameError("");
                  setOfferValueError("");
                  setOfferCategoryError("");
                  setOfferTypeError("");
                  setValidToError("");
                  setValidFromError("");
                  setStatusError("");
                  setIsSubmitButtonPressed(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          const updateData = {
            brandOfferDTO: {
              id: id, // id
              brandId: brandId,
              priceId: selectedGarment ? selectedGarment : null, // null for service
              name: input.offerName,
              value: input.offerValue,
              offerCategory: {
                id: input.offerCategory,
              },
              offerType: {
                id: input.offerType,
              },
              validFrom: input.validFrom.toISOString(),
              validTo: input.validTo.toISOString(),
              status: input.status,
            },
            itemList: selectedServices.length > 0 ? selectedServices : [],
          };
          // Call the service function for creating pickup request
          updateBrandOffer(brandId, updateData)
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res) {
                  // Reset state variables
                  if (Res.status === true) {
                    setModalVisible(true);
                    setModalStatus("success");
                    setModalText(Res.message);
                    setTimeout(() => {
                      navigate("/OffersManagement");
                    }, 1500);
                  } else {
                    setModalVisible(true);
                    setModalStatus("not Success");
                    setModalText(Res.message);
                  }

                  setInput({
                    offerName: "",
                    offerValue: "",
                    offerCategory: "",
                    offerType: "",
                    validTo: new Date(initialDate),
                    validFrom: new Date(initialDate),
                    status: "",
                  });
                  setSelectedServices([]);
                  setSelectedGarment([]);

                  setOfferNameError("");
                  setOfferValueError("");
                  setOfferCategoryError("");
                  setOfferTypeError("");
                  setValidToError("");
                  setValidFromError("");
                  setStatusError("");
                  setIsSubmitButtonPressed(false);
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    } else {
      setIsSubmitButtonPressed(false);
    }
  };

  // const validTo = new Date('2024-06-17T00:00:00.000Z');
  const validTo = new Date(input.validTo);
  const currentDate = new Date();
  // Calculate the difference in milliseconds
  const timeDifference = validTo - currentDate;

  return (
    <div className="flex-1" style={{ backgroundColor: "#FAF9F6" }}>
      <div
        className="h-3rem surface-0 sticky z-2 mb-3 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/OffersManagement")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Offers {id ? "Edit " : "Create"}
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <FloatLabel>
            <InputText
              id="offerName"
              value={input.offerName}
              onChange={(e) => {
                setInput({
                  ...input,
                  offerName: e.target.value,
                });
                setOfferNameError("");
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {offerNameError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {offerNameError}
              </p>
            )}

            <label
              htmlFor="offerName"
              className="text-md"
              style={{ color: "blue" }}
            >
              Offer Name <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>

        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <InputText
              id="offerValue"
              value={input.offerValue}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*$/.test(value)) {
                  setInput({
                    ...input,
                    offerValue: value,
                  });

                  setOfferValueError("");
                }
              }}
              className="w-full text-xl p-2 border-round-xl shadow-2"
              style={{
                backgroundColor: "#fff",
              }}
            />
            {offerValueError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {offerValueError}
              </p>
            )}

            <label
              htmlFor="offerValue"
              className="text-md"
              style={{ color: "blue" }}
            >
              Value <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4 flex-1">
          <div className="flex-auto">
            <FloatLabel>
              <Calendar
                id="ValidFromDatePicker"
                value={input.validFrom}
                onChange={(e) => {
                  handleValidFromDateChange(e.target.value);
                }}
                showIcon
                minDate={minimumDate}
                maxDate={input.validTo}
                disabled={timeDifference < 0 ? true : false}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
              <label
                htmlFor="ValidFromDatePicker"
                className="text-md"
                style={{ color: "blue" }}
              >
                Valid From <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
            {timeDifference < 0 && (
              <p className="text-md font-normal p-0" style={{ color: "red" }}>
                Please Select the valid to date
              </p>
            )}
            {validFromError && (
              <p className="text-md font-normal p-0" style={{ color: "red" }}>
                {validFromError}
              </p>
            )}
          </div>
        </div>
        <div className="mx-4 mt-4 flex-1">
          <div className="flex-auto">
            <FloatLabel>
              <Calendar
                id="ValidToDatePicker"
                value={input.validTo}
                onChange={(e) => {
                  handleValidToDateChange(e.target.value);
                }}
                showIcon
                minDate={input.validFrom}
                maxDate={maximumValidDate}
                className="w-full  bg-white-alpha-20 border-round-lg p-1 text-lg text-primary-50"
                dateFormat="dd/mm/yy"
              />
              <label
                htmlFor="ValidToDatePicker"
                className="text-md"
                style={{ color: "blue" }}
              >
                Valid To <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>
      </div>
      <div className="flex flex-1 mb-3">
        <div className="mx-4 mt-4  flex-1">
          <FloatLabel>
            <Dropdown
              id="offerCategory"
              value={input.offerCategory}
              onChange={(e) => handleOfferCategoryChange(e.target.value)}
              options={offerCategory}
              optionLabel="name"
              placeholder="Offer Category"
              className="w-full border-round-xl  text-2xl text-xl shadow-2"
            />
            {offerCategoryError && (
              <p className="text-lg font-normal" style={{ color: "red" }}>
                {offerCategoryError}
              </p>
            )}
            <label
              htmlFor="offerCategory"
              className="text-md"
              style={{ color: "blue" }}
            >
              Offer Category <span style={{ color: "red" }}>*</span>
            </label>
          </FloatLabel>
          <div className="mt-4  flex-1">
            <FloatLabel>
              <Dropdown
                id="offerType"
                value={input.offerType}
                onChange={(e) => handleOfferTypeChange(e.target.value)}
                options={offerTypeData}
                optionLabel="name"
                placeholder="Offer Type"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {offerTypeError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {offerTypeError}
                </p>
              )}
              <label
                htmlFor="offerType"
                className="text-md"
                style={{ color: "blue" }}
              >
                Offer Type <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
          <div className=" mt-4  flex-1">
            <FloatLabel>
              <Dropdown
                id="statusValue"
                value={input.status}
                onChange={(e) =>
                  setInput({
                    ...input,
                    status: e.value,
                  })
                }
                options={StatusList}
                optionLabel="name"
                placeholder="Status"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {statusError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {statusError}
                </p>
              )}
              <label
                htmlFor="statusValue"
                className="text-md"
                style={{ color: "blue" }}
              >
                Status <span style={{ color: "red" }}>*</span>
              </label>
            </FloatLabel>
          </div>
        </div>

        {input.offerCategory === 1 && (
          <div
            className="flex flex-1 flex border-round-xl  justify-content-between align-items-center px-4"
            style={{
              backgroundImage:
                "radial-gradient(circle at left top, #fff, #fff)",
            }}
          >
            <div
              className="h-12rem my-2 flex-1"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4  flex-1">
                <div className="flex flex-1 justify-content-between my-1">
                  <p className="text-xl font-medium" style={{ color: "blue" }}>
                    All
                  </p>
                  <div>
                    <div>
                      <Checkbox
                        checked={selectAll}
                        size="20" // Increased size
                        color="#00A3FF"
                        uncheckedColor="#75879B"
                        onClick={() => handleServicesToggle("All")}
                      />
                    </div>
                  </div>
                </div>
                {appServiceList?.map((item) => (
                  <div
                    key={item.appService.name}
                    className="flex flex-1 justify-content-between my-1"
                  >
                    <p className="text-xl font-medium">
                      {item.appService.name}
                    </p>
                    <div>
                      <Checkbox
                        size="20" // Increased size
                        checked={selectedServices.includes(item.appService.id)}
                        color={
                          selectedServices.includes(item.appService.id)
                            ? "#00A3FF"
                            : "#C1C9D3"
                        }
                        onClick={() => handleServicesToggle(item.appService.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
              {serviceError && <p>{serviceError}</p>}
            </div>
          </div>
        )}

        {input.offerCategory === 2 && (
          <div
            className="flex flex-1 flex border-round-xl  justify-content-between align-items-center px-4"
            style={{
              backgroundImage:
                "radial-gradient(circle at left top, #fff, #fff)",
            }}
          >
            <div
              className="h-12rem my-2 flex-1"
              style={{
                overflowY: "scroll",
              }}
            >
              <div className="mx-4  flex-1">
                <div className="flex flex-1 justify-content-between my-1">
                  <p className="text-xl font-medium" style={{ color: "blue" }}>
                    Select Tariff
                  </p>
                </div>
                {priceListData?.map((item, index) => (
                  <div
                    key={item.id}
                    className="flex flex-1 justify-content-between my-1"
                  >
                    <p className="text-xl font-medium">{item.priceCode}</p>
                    <div>
                      <Checkbox
                        key={index}
                        checked={selectedGarment === item.id}
                        color={
                          selectedGarment === item.id ? "#00A3FF" : "#C1C9D3"
                        }
                        onClick={() => handleGarmentsToggle(item.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
              {garmentError && <p>{garmentError}</p>}
            </div>
          </div>
        )}
      </div>

      <SuccessModal
        setModalVisible={setModalVisible}
        modalVisible={modalVisible}
        status={modalStatus}
        text={modalText}
      />

      <div className="flex ">
        <Button
          className="mt-1 mb-3 mx-4 border-round-xl w-full"
          onClick={handleSubmit}
          disabled={isSubmitButtonPressed}
        >
          <p className=" w-full text-2xl font-semibold flex justify-content-center">
            Submit
          </p>
        </Button>
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default OffersManagementCreate;
